import { GDPR_SETTINGS } from 'constants/application';

export const getGDPRSettings = (): any =>
  JSON.parse(localStorage.getItem(GDPR_SETTINGS) as string);

export const saveGDPRSettings = (settings: any): void => localStorage
  .setItem(GDPR_SETTINGS, JSON.stringify(settings));
